import { render } from "./navigation_entry.vue?vue&type=template&id=0fc7e714"
import script from "./navigation_entry.js?vue&type=script&lang=js"
export * from "./navigation_entry.js?vue&type=script&lang=js"

import "./navigation_entry.vue?vue&type=style&index=0&id=0fc7e714&lang=scss"

import exportComponent from "/opt/pleroma-fe/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__